import * as types from 'actions/promocode/types';

const initialState = {
  isLoading: false,
  code: '',
  result: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH:
      return {
        ...state,
        isLoading: true,
        result: null,
      };
    case types.FETCH_SUCCESS:
      return { ...state, isLoading: false, result: action.payload };
    case types.RESET_RESULT:
      return { ...state, result: null };

    default:
      return state;
  }
};
